// extracted by mini-css-extract-plugin
export default {"SpaceComponent":"space-component_SpaceComponent__DQaGS","SpaceComponentButtons":"space-component_SpaceComponentButtons__t+3SP","gapsLine":"space-component_gapsLine__nv-r1"};